import { takeEvery, call, put, fork } from "redux-saga/effects";
import * as actions from "../../actions/agencies";
import {
  createAgencyPayload,
  types,
  updateAgencyPayload,
} from "../../actions";
import * as api from "../../api/agencies";
import { AgencyAdminStoreError } from "../../enums/store-messages/admin";
import { IsResponseValidUtil } from "../../utils/api-utils";
import { Agency, JogId } from "../../reducers/states/agency";
import { MakeJogs } from "../../reducers/states/agency/jogs";

export function* createAgency(action: {
  type: typeof types.CREATE_AGENCY;
  payload: createAgencyPayload
}): Generator<any, void, unknown> {
  try {
    const result: any = yield call(api.postAgency, {
      ...action.payload
    });

    // todo: jcavner: I'll need the response to return the ID of the newly created Agency, or possibly the whole object, for what I'm planning.
    // I want to update the Agency state by inserting the new Agency, not calling Get Agencies to pull all of them.
    if (result && result.status === 200 && IsResponseValidUtil(result.data)) {
      yield put(actions.createAgencySuccess());
    } else {
      yield put(actions.createAgencyFailure());
    }
  } catch (e) {
    console.log(e);
    yield put(actions.createAgencyFailure());
  }
}
function* watchCreateAgencyEvent() {
  yield takeEvery(types.CREATE_AGENCY, createAgency);
}

export function* getAgencies(action: {
  type: typeof types.GET_AGENCIES;
}): Generator<any, void, unknown> {
  try {
    const result: any = yield call(api.getAgencies);
    if (result && result.status === 200 && IsResponseValidUtil(result.data)) {
      const agencies: Agency[] = (result.data as Agency[]).map(a => {
        return {
          ...a,
          // todo: jcavner: GET is not returning primary contact fields. But "primary contact" is a feature that will be delayed for now.
          jogId: a.jogIds?.[0] as JogId || JogId.NOT_SELECTED,
          jogIds: a.jogIds?.map(id => id.toString().padStart(2, "0")), // Agencies have their jogIds stored in Number sets. But the actual JOG ids are zero padded strings.
        }
      }).sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: "base" }));

      const jogs = MakeJogs(agencies).sort((a, b) => a.shortName.localeCompare(b.shortName, undefined, { sensitivity: "base" }));

      yield put(actions.getAgenciesSuccess(agencies, jogs));
    } else {
      yield put(actions.getAgenciesFailure(AgencyAdminStoreError.GET_AGENCIES_ERROR));
    }
  } catch (e) {
    console.log(e);
    yield put(actions.getAgenciesFailure(AgencyAdminStoreError.GET_AGENCIES_ERROR));
  }
}
function* watchGetAgenciesEvent() {
  yield takeEvery(types.GET_AGENCIES, getAgencies);
}

export function* updateAgency(action: {
  type: typeof types.UPDATE_AGENCY;
  payload: updateAgencyPayload
}): Generator<any, void, unknown> {
  try {
    const result: any = yield call(api.putAgency, {
      ...action.payload
    });

    // todo: jcavner: I should ideally have the response return the updated object for what I'm planning.
    // I want to update the Agency state by replacing the existing object with the returned object for the updated Agency, and not call Get Agencies to pull all of them.
    if (result && result.status === 200 && IsResponseValidUtil(result.data)) {
      yield put(actions.updateAgencySuccess());
    } else {
      yield put(actions.updateAgencyFailure());
    }
  } catch (e) {
    console.log(e);
    yield put(actions.updateAgencyFailure());
  }
}
function* watchUpdateAgencyEvent() {
  yield takeEvery(types.UPDATE_AGENCY, updateAgency);
}

const agenciesSagas = [
  fork(watchCreateAgencyEvent),
  fork(watchGetAgenciesEvent),
  fork(watchUpdateAgencyEvent),
];

export default agenciesSagas;
